// Search Bar Icons and Names

// Home
import {AiOutlineHome} from "react-icons/ai";
// shorts
import {MdOutlineVideoLibrary} from "react-icons/md"
// subcription
import {MdSubscriptions} from "react-icons/md"
// Music
import {SiYoutubemusic} from "react-icons/si"
// Library
import {MdOutlineLibraryAdd} from "react-icons/md";
// videos
import {MdLiveTv} from "react-icons/md"
// watch Later
import {LuListVideo} from "react-icons/lu" 
// Trendng
import {AiFillFire} from "react-icons/ai" 
// shopping
import {AiOutlineShopping} from "react-icons/ai" 
// Music
import {BsMusicNote} from "react-icons/bs" 
// Games
import {IoGameController} from "react-icons/io5" 
// sports
import {MdSportsCricket} from "react-icons/md" 
// Settings
import {AiFillSetting} from "react-icons/ai" 
// Help
import {BiHelpCircle} from "react-icons/bi" 
// FeedBack
import {MdFeedback} from "react-icons/md"



export const sideBarIconList=[{
    name:"Home",
    key:<AiOutlineHome/>
  },{
    name:"Shorts",
    key:<MdOutlineVideoLibrary/>
  },{
    name:"Subscriptions",
    key:<MdSubscriptions/>
  },{
    name:"Music",
    key:<SiYoutubemusic/>
  },{
    name:"Library",
    key:<MdOutlineLibraryAdd/>
  },{
    name:"Videos",
    key:<MdLiveTv/>
  },{
    name:"Watch Later",
    key:<LuListVideo/>
  },{
    name:"Trending",
    key:<AiFillFire/>
  },{
    name:"Shopping",
    key:<AiOutlineShopping/>
  },{
    name:"Music",
    key:<BsMusicNote/>
  },{
    name:"Games",
    key:<IoGameController/>
  },{
    name:"Sports",
    key:<MdSportsCricket/>
  },{
    name:"Settings",
    key:<AiFillSetting/>
  },{
    name:"Help",
    key:<BiHelpCircle/>
  },{
    name:"Feedback",
    key:<MdFeedback/>
  }]
      